import { useContext, useEffect, useState } from 'react';
import CardOne from '../Cards/CardOne/CardOne';
import './Accueil.scss';
import { CurrentLangContext, LangContext } from '../../contexts/contexts';

function Accueil() {
  const realEstateList = {
    rentList: [
      {city: "Gambie", location: "Serrekunda", price: "17 000$", type: "Appartement", img: "#"},
      {city: "Gambie", location: "Brikama", price: "18 000$", type: "Appartement", img: "#"},
      {city: "Gambie", location: "Bakau", price: "19 000$", type: "Appartement", img: "#"},
      {city: "Gambie", location: "Banjul", price: "20 000$", type: "Appartement", img: "#"},
      {city: "Gambie", location: "Brikama", price: "21 000$", type: "Appartement", img: "#"},
      {city: "Gambie", location: "Banjul", price: "22 000$", type: "Appartement", img: "#"},
      {city: "Gambie", location: "Bakau", price: "23 000$", type: "Appartement", img: "#"},
      {city: "Sénégal", location: "Dakar", price: "23 000$", type: "Appartement", img: "#"},
      {city: "Sénégal", location: "Pikine", price: "21 000$", type: "Appartement", img: "#"},
      {city: "Sénégal", location: "Dakar", price: "22 000$", type: "Appartement", img: "#"},
      {city: "Sénégal", location: "Touba", price: "23 000$", type: "Appartement", img: "#"},
    ],
    buyList: [
      {city: "Sénégal", location: "Pikine", price: "17 000$", type: "Terrain", img: "#"},
      {city: "Sénégal", location: "Dakar", price: "18 000$", type: "Terrain", img: "#"},
      {city: "Sénégal", location: "Touba", price: "19 000$", type: "Terrain", img: "#"},
      {city: "Sénégal", location: "Dakar", price: "20 000$", type: "Terrain", img: "#"},
      {city: "Sénégal", location: "Touba", price: "17 000$", type: "Terrain", img: "#"},
      {city: "Gambie", location: "Serrekunda", price: "18 000$", type: "Terrain", img: "#"},
      {city: "Gambie", location: "Bakau", price: "19 000$", type: "Terrain", img: "#"},
      {city: "Gambie", location: "Banjul", price: "20 000$", type: "Terrain", img: "#"},
      {city: "Gambie", location: "Brikama", price: "21 000$", type: "Terrain", img: "#"},
      {city: "Gambie", location: "Bakau", price: "22 000$", type: "Terrain", img: "#"},
      {city: "Gambie", location: "Serrekunda", price: "23 000$", type: "Terrain", img: "#"},
      {city: "Gambie", location: "Banjul", price: "22 000$", type: "Terrain", img: "#"},
    ],
  }

  function viewSearch (city, list) {
    let currentL = "realEstateList."+list+"List";
    return (
      eval(currentL).filter((i) => {
        return i.city.toLowerCase() === city.toLowerCase()
      })
    )
  };

  const [currentSearch, setCurrentSearch] = useState("buy");
  const [citySearch, setCitySearch] = useState("Gambie");
  const [locationSearch, setLocationSearch] = useState("");
  const [currentList, setCurrentList] = useState(viewSearch(citySearch, currentSearch));

  function handleSearch (city, location, list) {
    let currentL = "realEstateList."+list+"List";
    return (
      eval(currentL).filter((i) => {
        return i.city.toLowerCase() === city.toLowerCase() && i.location.toLowerCase() === location.toLowerCase()
      })
    )
  };

  const langs = useContext(LangContext);
  const homeLangs = langs.home;

  const CurrentLangC = useContext(CurrentLangContext);
  const currentLang = CurrentLangC[0];
  
  return (
    <section className="Accueil">
      <div className="Accueil_container">
        <div className="accueil_search">
          <div className="search_container">
            <div className="search_titles">
              <p
                className={`search_rent ${currentSearch === "rent" ? "currentSearchColor" : "baseSearchColor"}`}
                onClick={() => {
                  setCurrentSearch("rent");
                  setCurrentList(viewSearch(citySearch, currentSearch));
                }}
              >{homeLangs.search[currentLang][0]}</p>
              <p
                className={`search_buy ${currentSearch === "buy" ? "currentSearchColor" : "baseSearchColor"}`}
                onClick={() => {
                  setCurrentSearch("buy");
                  setCurrentList(viewSearch(citySearch, currentSearch));
                }}
              >{homeLangs.search[currentLang][1]}</p>
            </div>

            <form
              action="" method="" className="search_content"
              onSubmit={(e) => {
                e.preventDefault();

                let citySelect = document.querySelector(`#ville_search_${currentSearch === "buy" ? "buy" : currentSearch === "rent" && "rent"}`);
                let LocationInput = document.querySelector(`#location_search_${currentSearch === "buy" ? "buy" : currentSearch === "rent" && "rent"}`);

                if (locationSearch === "") {
                  LocationInput.focus();
                } else {
                    setLocationSearch("");
                    setCurrentList(handleSearch(citySelect.value, LocationInput.value, currentSearch))
                    console.log("submit", currentList);
                  }
              }}
            >
              <div className="search">
                <label htmlFor={`ville_search_${currentSearch === "buy" ? "buy" : currentSearch === "rent" && "rent"}`}>{homeLangs.search[currentLang][2]}:
                  <select
                    id={`ville_search_${currentSearch === "buy" ? "buy" : currentSearch === "rent" && "rent"}`} name="" placeholder={homeLangs.search[currentLang][2]}
                    value={citySearch}
                    onChange={(e) => {
                      setCitySearch(e.target.value);
                      setCurrentList(viewSearch(citySearch, currentSearch));
                    }}
                  >
                    <option value="gambie">Gambie</option>
                    <option value="sénégal">Sénégal</option>
                  </select>
                  {/* <input 
                    type="search"
                    id={`ville_search_${currentSearch === "buy" ? "buy" : currentSearch === "rent" && "rent"}`} name="" placeholder={homeLangs.search[currentLang][2]}
                    value={citySearch}
                    onChange={(e) => setCitySearch(e.target.value)}
                  /> */}
                </label>
                <label htmlFor={`location_search_${currentSearch === "buy" ? "buy" : currentSearch === "rent" && "rent"}`}>{homeLangs.search[currentLang][3]}:
                  <input 
                    type="search"
                    id={`location_search_${currentSearch === "buy" ? "buy" : currentSearch === "rent" && "rent"}`} name="" placeholder={homeLangs.search[currentLang][3]}
                    value={locationSearch}
                    onChange={(e) => setLocationSearch(e.target.value)}
                  />
                </label>
              </div>

              <div className="button">
                <button type="submit">{homeLangs.search[currentLang][4]}</button>
              </div>
            </form>
          </div>
        </div>

        <div className="accueil_immo">
          <div className="immo_content">
            <div className="immo">
              {Array.isArray(currentList) && currentList.map((element, index) => 
                <CardOne price={element.price} type={element.type} img={element.img} key={index} />
              )}
              {(Array.isArray(currentList) && currentList.length === 0) && <p className="result_search">{homeLangs.result[currentLang][1]}</p>}
              {currentList == null && <p className="result_search">{homeLangs.result[currentLang][0]}</p>}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Accueil;